import React, { Component } from 'react';
import { Button, Form } from 'semantic-ui-react';
import { reduxForm, Field, Fields } from 'redux-form';
import PropTypes from 'prop-types';

import { CLOSE_SCHOOL_YEAR_FORM_NAME } from 'Common/FormEnum';
import { ToggleField, SelectField } from 'Common/SemanticWrapper';
import { CloseSchoolYearFormEnum } from 'Common/FieldEnum';

class CloseSchoolYearForm extends Component {
  static propTypes = {
    loading: PropTypes.bool.isRequired,
  };

  state = {};

  deleteGradeFields = fields => (
    <React.Fragment>
      <ToggleField
        label="Delete students from grade"
        {...fields[CloseSchoolYearFormEnum.ShouldDeleteGrade]}
      />

      <SelectField
        options={this.props.gradeOptions}
        label="Grade to delete"
        multiple
        {...fields[CloseSchoolYearFormEnum.GradeIds]}
        disabled={
          !fields[CloseSchoolYearFormEnum.ShouldDeleteGrade].input.value
        }
      />
    </React.Fragment>
  );

  render() {
    const { loading, submit, fiscalYear } = this.props;

    return (
      <React.Fragment>
        <Form>
          <Field
            name={CloseSchoolYearFormEnum.DoNotDeleteWithdrawnWithBalance}
            component={ToggleField}
            label="Do not delete withdrawn students with account balances"
          />
          <Fields
            names={[
              CloseSchoolYearFormEnum.ShouldDeleteGrade,
              CloseSchoolYearFormEnum.GradeIds,
            ]}
            component={this.deleteGradeFields}
          />

          <Button
            primary
            size="big"
            disabled={loading}
            loading={loading}
            onClick={submit}
          >
            Close School Year {fiscalYear}
          </Button>
        </Form>
      </React.Fragment>
    );
  }
}

const validator = values => {
  const errors = {};

  if (
    values[CloseSchoolYearFormEnum.ShouldDeleteGrade] &&
    !values[CloseSchoolYearFormEnum.GradeIds].length
  ) {
    errors[CloseSchoolYearFormEnum.GradeIds] = 'Please choose a grade.';
  }

  return errors;
};

export default reduxForm({
  form: CLOSE_SCHOOL_YEAR_FORM_NAME,
  validate: validator,
  enableReinitialize: true,
})(CloseSchoolYearForm);



// WEBPACK FOOTER //
// ./src/pages/CloseSchoolYear/components/CloseSchoolYearForm.js